import img1 from '../Assets/Cards/1.svg';
import img2 from '../Assets/Cards/2.svg';
import img3 from '../Assets/Cards/3.svg';
import img4 from '../Assets/Cards/4.svg';

const Cards_Data = [
    {
        img: img1,
        title: "Innovative Solutions",
        des: "We craft tailored IT and e-commerce solutions that propel your business forward, ensuring you stay ahead in the digital landscape."
    },
    {
        img: img2,
        title: "Comprehensive Services",
        des: "We craft tailored IT and e-commerce solutions that propel your business forward, ensuring you stay ahead in the digital landscape."
    },
    {
        img: img3,
        title: "Expert Team",
        des: "We craft tailored IT and e-commerce solutions that propel your business forward, ensuring you stay ahead in the digital landscape."
    },
    {
        img: img4,
        title: "Client-Centric Approach",
        des: "We craft tailored IT and e-commerce solutions that propel your business forward, ensuring you stay ahead in the digital landscape."
    },
];

export default Cards_Data;
